import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';

export const selectEventState = (state: AppState) =>
  state.event;


export const selectEmailConfigs = createSelector(
  selectEventState,
  (state) => state.emailConfigs
);

export const selectManeuverConfigs = createSelector(
  selectEventState,
  (state) => state.maneuverConfigs
);

export const selectManeuverNotifUpdated = createSelector(
  selectEventState,
  (state) => state.maneuverNotifUpdated
);
export const selectManeuverNotifCreated = createSelector(
  selectEventState,
  (state) => state.maneuverNotifCreated
);
export const selectManeuverNotifDeleted = createSelector(
  selectEventState,
  (state) => state.maneuverNotifDeleted
);
export const selectEventsLoading = createSelector(
  selectEventState,
  (state) => state.eventsLoading
);
export const selectEvents = createSelector(
  selectEventState,
  (state) => state.events
);
export const selectEventsPaging = createSelector(
  selectEventState,
  (state) => state.paging
);
export const selectEventsPagination = createSelector(
  selectEventState,
  (state) => state.pagination
);
export const selectEventsFilter = createSelector(
  selectEventState,
  (state) => state.filter
);
export const selectEventTypes = createSelector(
  selectEventState,
  (state) => state.eventTypes
);
export const selectEventsAllLoading = createSelector(
  selectEventState,
  (state) => state.eventsAllLoading
);
export const selectEventsAll = createSelector(
  selectEventState,
  (state) => state.eventsAll
);
export const selectEventsAllPaging = createSelector(
  selectEventState,
  (state) => state.pagingAll
);
